// @flow

import _ from 'lodash';

import ApiObject from '../ApiObject';
import ProDomain from './ProDomain';

export default class ProDomainsList extends ApiObject {

  domains: Array<ProDomain> = [];

  postJsonAssignation(data: Object) {
    this.domains = [];
    _.each(data, (domainData) => {
      const proDomain: ProDomain = new ProDomain();
      proDomain.fromJson(domainData);

      // fix some weird bug where a wrong pro domain object is created.
      if (!_.isUndefined(proDomain.id)) {
        this.domains.push(proDomain);
      }
    });
  }

  getDomainWithId(domainIdToFind: string) {
    let foundDomain:ProDomain = _.find(this.domains, (domain: ProDomain) => {
      return domain.id === domainIdToFind;
    });

    return _.isUndefined(foundDomain) ? null : foundDomain;
  }

  numberOfDomains(): number {
    return this.domains.length;
  }
}
